import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-statclient',
  templateUrl: './statclient.component.html',
  styleUrls: ['./statclient.component.scss']
})
export class StatclientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
